export const toastConfig = {
  position: "bottom-center",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className: "black-background",
  bodyClassName: "grow-font-size"
};
